import { UserForegroundDomainEnum } from './user-foreground-domain-enum'

export interface InterviewReflectionInterface {
  id?: number
  /**
   * 活动任务 ID
   */
  activityTaskId?: number
  /**
   * 用户 ID
   */
  rid?: number
  reflectionDomain?: UserForegroundDomainEnum | null
  /**
   * 面试官 ID
   */
  interviewerId?: number
  /**
   * 面试结果 ID
   */
  interviewResultId?: number
  /**
   * 面试描述
   */
  interviewDescription?: string
  /**
   * 面试时间
   */
  interviewedAt?: string
  /**
   * 面试结果
   *  - expand
   */
  interviewResult?: string
  /**
   * 面试官名
   *  - expand
   */
  interviewAdminName?: string
}

export class InterviewReflection implements InterviewReflectionInterface {
  id?: number
  /**
   * 活动任务 ID
   */
  activityTaskId?: number
  /**
   * 用户 ID
   */
  rid?: number
  reflectionDomain?: UserForegroundDomainEnum | null
  /**
   * 面试官 ID
   */
  interviewerId?: number
  /**
   * 面试结果 ID
   */
  interviewResultId?: number
  /**
   * 面试描述
   */
  interviewDescription?: string
  /**
   * 面试时间
   */
  interviewedAt?: string
  /**
   * 面试结果
   *  - expand
   */
  interviewResult?: string
  /**
   * 面试官名
   *  - expand
   */
  interviewAdminName?: string

  constructor(props: InterviewReflectionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      id: _id,
      activityTaskId: _activityTaskId,
      rid: _rid,
      reflectionDomain: _reflectionDomain,
      interviewerId: _interviewerId,
      interviewResultId: _interviewResultId,
      interviewDescription: _interviewDescription,
      interviewedAt: _interviewedAt,
      interviewResult: _interviewResult,
      interviewAdminName: _interviewAdminName,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.id = _id
    this.activityTaskId = _activityTaskId
    this.rid = _rid
    this.reflectionDomain = _reflectionDomain
    this.interviewerId = _interviewerId
    this.interviewResultId = _interviewResultId
    this.interviewDescription = _interviewDescription
    this.interviewedAt = _interviewedAt
    this.interviewResult = _interviewResult
    this.interviewAdminName = _interviewAdminName
  }
}
